import { CriterionType } from '../../types/screener.type';
import valuationAC from './AC/valuationAC';
import dividendAC from './AC/dividendAC';
import shareRelatedAC from './AC/shareRelatedAC';
import profitabilityRatioAC from './AC/profitabilityRatioAC';
import managementEffectivenessAC from './AC/managementEffectivenessAC';
import financialStrengthAC from './AC/financialStrengthAC';
import efficiencyRatiosAC from './AC/efficiencyRatiosAC';
import growthRatesAC from './AC/growthRatesAC';
import pricePerformanceAC from './AC/pricePerformanceAC';
import consensusEstimatesAC from './AC/consensusRevenueEstimatesAC';
import comanyScoreAC from './AC/companyScoreAC';
import macroSensitivityAC from './AC/macroSensitivityAC';
import volumeAC from './AC/volumeAC';
import technicalIndicatorTrendAC from './AC/technicalIndicatorTrendAC';
import technicalIndicatorOscillatorAC from './AC/technicalIndicatorOscillatorAC';

const AdvanceCriteria: CriterionType[] = [
  ...valuationAC,
  ...dividendAC,
  ...shareRelatedAC,
  ...profitabilityRatioAC,
  ...managementEffectivenessAC,
  ...financialStrengthAC,
  ...efficiencyRatiosAC,
  ...growthRatesAC,
  ...consensusEstimatesAC,
  ...comanyScoreAC,
  ...macroSensitivityAC,
  ...pricePerformanceAC,
  ...volumeAC,
  ...technicalIndicatorTrendAC,
  ...technicalIndicatorOscillatorAC,
];

export default AdvanceCriteria;
